import { createElement } from 'react';
import { Tab } from '@alifd/next';
import './index.scss';
const OadpTabItem = function OadpTabItem({ name, title, children, disabled, closeable, ...otherProps }) {
    return (createElement(Tab.Item, Object.assign({ title: title, disabled: disabled, closeable: closeable }, otherProps), children));
};
export default OadpTabItem;
